module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('day-hours-editor', {
    attrs: {
      "title": "Monday"
    },
    model: {
      value: (_vm.value.monday),
      callback: function($$v) {
        _vm.$set(_vm.value, "monday", $$v)
      },
      expression: "value.monday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Tuesday"
    },
    model: {
      value: (_vm.value.tuesday),
      callback: function($$v) {
        _vm.$set(_vm.value, "tuesday", $$v)
      },
      expression: "value.tuesday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Wednesday"
    },
    model: {
      value: (_vm.value.wednesday),
      callback: function($$v) {
        _vm.$set(_vm.value, "wednesday", $$v)
      },
      expression: "value.wednesday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Thursday"
    },
    model: {
      value: (_vm.value.thursday),
      callback: function($$v) {
        _vm.$set(_vm.value, "thursday", $$v)
      },
      expression: "value.thursday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Friday"
    },
    model: {
      value: (_vm.value.friday),
      callback: function($$v) {
        _vm.$set(_vm.value, "friday", $$v)
      },
      expression: "value.friday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Saturday"
    },
    model: {
      value: (_vm.value.saturday),
      callback: function($$v) {
        _vm.$set(_vm.value, "saturday", $$v)
      },
      expression: "value.saturday"
    }
  }), _vm._v(" "), _c('day-hours-editor', {
    attrs: {
      "title": "Sunday"
    },
    model: {
      value: (_vm.value.sunday),
      callback: function($$v) {
        _vm.$set(_vm.value, "sunday", $$v)
      },
      expression: "value.sunday"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f08acd50"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/HoursEditor.vue
// module id = 380
// module chunks = 4